export const ROUTES_PATH = {
  MAIN: '/',
  ADMIN: '/admin',
  LOGIN: '/login',
  SIGNUP: '/signup',
  ERROR: '/error',
};
